query HockeyTeamByTeamId (
  $teamId: UUID!
){
  team: hockeyTeamByTeamId(teamId: $teamId) {
    squad
    teamId
    playerMappedForProjections: hockeyTeamPlayerProjectionsMappedsByTeamId {
      nodes {
        playerId
      }
    }
  }
}
